










































































































/* Created- 28 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardMax.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { ButtonConfig, ButtonType } from "../../../Models/Buttons";
import { ParticaEvent, eParticaAction, getActionName } from "../../../Models/ParticaEvent";
import ParticaTitleBase from "../../Base/ParticaTitleBase.vue";
import { IArticleMetadataDTO, PublicationModel, IssueModel, SectionModel } from "../../../Generated/ParticaAPI";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";
import ParticaCardFill from "@/Ui-Components/Common/Container/ParticaCardFill.vue";
import { Article, IMetadataArticle } from "../../../Models/ArticleModels/article";
import { IPublicationService } from "../../../BusinessServices/publication";
import { ISectionService } from "../../../BusinessServices/section";
import MetadataList from "../../../Ui-Components/Article/Metadata/MetadataList.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import { IMetadataService } from "../../../BusinessServices/metadataarticles";
import { ArrayUtils } from "../../../BusinessServices/arrayutils";



@Component(
	{
		name: "MetadataImport",
		components: {
			ButtonList,
			ParticaCard,
			ParticaView,
			ParticaRightDrawer,
			ParticaCardFill,
			MetadataList,
			ParticaRowContainer
		}
	})
export default class MetadataImport extends ParticaTitleBase {
	@Prop() private id: number;
	private gapi: any;
	private loggedIn: boolean = false;
	private sheetId: string = "1afLl74DuFTYMqdmwi8jZx72Z9lZNZDzK1vHRNiZGMNA";
	private sheetName: string = "Sheet2";
	private headers: string[] = [];
	private sheetdata: string[][] = [];
	private buttons: ButtonConfig[] = [
		{ label: "Read Headers", action: eParticaAction.GOOGLESHEET_READ_HEADER, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Show Mapping", action: eParticaAction.GOOGLESHEET_MAPPING, type: ButtonType.Normal } as ButtonConfig,
	];
	private savebuttons: ButtonConfig[] = [
		{ label: "Save Metadata", action: eParticaAction.METADATA_SAVE, type: ButtonType.Normal } as ButtonConfig,
	];
	private loginbuttons: ButtonConfig[] = [
		{ label: "Login Google", action: eParticaAction.LOGIN_GOOGLE, type: ButtonType.Normal } as ButtonConfig,
	];
	private mapbuttons: ButtonConfig[] = [
		{ label: "Set Fields", action: eParticaAction.GOOGLESHEET_MAPPING_SET, type: ButtonType.Normal } as ButtonConfig,
	];
	private articles: IMetadataArticle[] = [];
	private showmapping: boolean = false;
	private mapping: string[] = [];

	private iIssue: number = 0;
	private iTitle: number = 1;
	private iSection: number = 2;
	private iPage: number = 3;
	private iAbstract: number = 4;
	private iKeywords: number = 5;
	private iContributors: number = 6;
	private iLocations: number = 7;
	private iBody: number = 8;
	private iSlug: number = 9;

	private publicationService: IPublicationService;
	private title: PublicationModel = new PublicationModel();

	private metadataService: IMetadataService;

	private sectionService: ISectionService;
	private sections: SectionModel[] = [];

	private getStringRowValue(row: string[], index: number): string {
		const x: number = this.headers.indexOf(this.mapping[index]);
		if (x > row.length) {
			return "";
		} else {
			return row[x];
		}
	}
	private getIntRowValue(row: string[], index: number): number {
		const x: number = this.headers.indexOf(this.mapping[index]);
		if (x > row.length) {
			throw new Error("Invalid number column in sheet. All number columns must have default value.");
		} else {
			return parseInt(row[x], 0);
		}
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.GOOGLESHEET_MAPPING: {
					this.showmapping = true;
					break;
				}
				case eParticaAction.METADATA_SAVE: {
					const groups = ArrayUtils.groupBy(this.articles, m => m.issueId);
					for (const key of Object.keys(groups)) {
						await this.metadataService.saveArticles(groups[key]);
					}

					this.ShowSnackbar("Metadata saved. Check viewer and search. You will need to re-publish issues for TOC changes to appear.");
					break;
				}
				case eParticaAction.GOOGLESHEET_MAPPING_SET: {
					this.showmapping = false;
					this.articles = [];
					this.sheetdata.forEach(row => {
						const item: IMetadataArticle = new Article() as IMetadataArticle;
						item.title = this.getStringRowValue(row, this.iTitle);
						item.abstract = this.getStringRowValue(row, this.iAbstract);
						item.slug = this.getStringRowValue(row, this.iSlug);
						item.pageNumber = this.getIntRowValue(row, this.iPage);
						const arrKeywords: string[] = ArrayUtils.splitString(this.getStringRowValue(row, this.iKeywords), "|");
						arrKeywords.forEach(k => { item.addKeyword(k); });

						// const arrLocations: string[] = ArrayUtils.splitString(this.getStringRowValue(row, this.iLocations), "|");
						// arrLocations.forEach(k => { item.addLocation(k); });

						const arrContributors: string[] = ArrayUtils.splitString(this.getStringRowValue(row, this.iContributors), "|");
						arrContributors.forEach(k => { item.addContributor(k); });




						if (this.title !== undefined && this.title.issues !== undefined) {
							const issuename: string = this.getStringRowValue(row, this.iIssue);
							const iss: IssueModel | undefined = this.title.issues.find(i => i.name === issuename);
							if (iss === undefined) {
								throw new Error(`Issue not found in publication. (${issuename})`);
							}
							item.issueId = iss.id as number;
						} else {
							throw new Error(`Issues not found in publication.`);
						}
						if (this.title.sections !== undefined) {
							const section: string = this.getStringRowValue(row, this.iSection);
							const sec: SectionModel | undefined = this.sections.find(s => s.name === section);
							if (sec === undefined) {
								throw new Error(`Section not found in publication. (${section})`);
							}
							item.sectionId = sec.id as number;
						} else {
							throw new Error(`Sections not found in publication.`);
						}
						this.articles.push(item);
					});
					this.articles = this.articles.sort(a => a.issueId);
					break;
				}
				case eParticaAction.GOOGLESHEET_READ_HEADER: {
					if (this.loggedIn === false) {
						this.ShowSnackbar("You are not logged in.");
						break;
					}
					if (this.sheetId === "") {
						this.ShowSnackbar("Enter a sheet Id");
						break;
					}
					const data = await this.gapi.client.sheets.spreadsheets.values.get({
						spreadsheetId: this.sheetId,
						range: this.sheetName + "!A1:Z",
					});
					this.headers = data.result.values.shift(); // grab first row for headers
					this.sheetdata = data.result.values;
					this.showmapping = true;
					break;
				}
				case eParticaAction.LOGIN_GOOGLE: {
					// @ts-ignore
					this.gapi = await this.$getGapiClient();
					await this.gapi.auth2.getAuthInstance().signIn();
					this.loggedIn = await this.gapi.auth2.getAuthInstance().isSignedIn.get() as boolean;
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	@Watch("route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Home";
		await this.init();
		await this.getTitleNav(this.id);
		this.breadcrumbs.pop();
	}

	private async init() {
		try {
			this.LoadingStart();
			this.publicationService = this.particaServices.getPublicationService();
			this.title = await this.publicationService.getTitle(this.id);
			this.sectionService = this.particaServices.getSectionService();
			this.sections = await this.sectionService.getSections(this.id);
			this.metadataService = this.particaServices.getMetadataService();
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
